<template>
  <!-- <div
    class="container"
    style="background: #ffffff; padding-top: 0px"
  >
    <div class="row text-start pt-5 mb-3">
      <div class="col-12">
        <h2 style="font-size: 36px;color: #51646B;" class="fw-bold">Log in</h2>
      </div>
    </div>
    <div class="row">
      <div class="mb-3">
        <input
          class="form-control"
          id="email"
          v-model="email"
          name="email"
          type="text"
          placeholder="email address"
        />
      </div>
      <div class="mb-3">
        <input
          class="form-control"
          id="password"
          v-model="password"
          name="password"
          type="password"
          placeholder="password"
        />
      </div>
      <div class="form-fields mb-3">
        <button class="signIn" @click="validateSignin">Log in</button>
        <div v-if="loading" style="text-align: center">
          <LoadingVue></LoadingVue>
        </div>
        <div v-if="errMsg !== ''" style="color: red">
          <span>{{ errMsg }}</span>
        </div>
        <div v-if="isVerifiedEmail == false" style="color: red">
          <span>Please Verified Your Email.</span>
        </div>
        <div class="footer mt-4" style="background-color: unset">
          <span
            >Don't have an account?
            <a
              href="/register-code"
              style="font-weight: bold; color: #ff8500"
            >
              Signup</a
            ></span
          >
        </div>
      </div>
    </div>
  </div> -->
  <div class="">
    <div class="container p-0">
      <div
        class="row justify-content-center align-items-center bg-form p-2"
        style="height: 100vh !important; overflow: auto"
      >
        <div class="col-12 text-start pt-5">
          <div class="">
            <div class="w-100">
              <div class="mb-3" style="height: 55px">
                <img src="@/assets/navBarLogo.png" alt="" height="100%" />
              </div>
              <div style="max-width: 550px" class="ms-auto me-auto">
                <div class="mb-3">
                  <span class="text-herder-login">{{ $t('TXT_LOG_INTO_YOUR_ACCOUNT') }}</span>
                </div>
                <div class="box p-3">
                  <div class="my-3">
                    <label for="email" style="color: #51646b"
                      >{{ $t('TXT_EMAIL_ADDRESS') }}</label
                    >
                    <input
                      id="email"
                      v-model="email"
                      name="email"
                      type="text"
                      placeholder="Email@address.com"
                      class="form-control"
                    />
                  </div>
                  <div class="mb-3">
                    <label for="password" style="color: #51646b">{{ $t('TXT_PASSWORD') }}</label>
                    <div class="form-group">
                      <input
                        v-model="password"
                        id="password-field"
                        name="password"
                        :type="isShowPassword ? 'text' : 'password'"
                        :placeholder="$t('TXT_PASSWORD_PLACEHOLDER')"
                        class="form-control"
                        value="secret"
                        @keyup.enter="validateSignin"
                      />
                      <svg
                        v-if="isShowPassword"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="currentColor"
                        class="bi bi-eye me-2 cursor-pointer"
                        style="
                          float: right;
                          margin-top: -28px;
                          position: relative;
                          z-index: 2;
                        "
                        viewBox="0 0 16 16"
                        @click="isShowPassword = !isShowPassword"
                      >
                        <path
                          d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                        />
                        <path
                          d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                        />
                      </svg>
                      <svg
                        v-if="isShowPassword == false"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="currentColor"
                        class="bi bi-eye-slash me-2 cursor-pointer"
                        style="
                          float: right;
                          margin-top: -28px;
                          position: relative;
                          z-index: 2;
                        "
                        viewBox="0 0 16 16"
                        @click="isShowPassword = !isShowPassword"
                      >
                        <path
                          d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                        />
                        <path
                          d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                        />
                        <path
                          d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                        />
                      </svg>
                    </div>
                    <!-- <span class="d-flex justify-content-end"><a href="/forgotpwd" class="forgot-password">
                        Forgot password?</a></span> -->
                  </div>
                  <div class="form-fields mb-3">
                    <button
                      v-if="!loading"
                      class="btn button-green"
                      :disabled="email == ''"
                      style="height: 90%"
                      @click="validateSignin"
                    >
                      {{ $t('TXT_LOG_IN') }}
                    </button>
                    <!-- <div class="d-flex justify-content-center my-2" style="color: #51646b">or</div>
                    <router-link to="/register" class="btn button-outline-green w-100 mb-3"
                      style="height: 90%;font-weight: 500;color: #1DB954; border-color: #1DB954;">Create account</router-link> -->
                    <div v-if="loading" style="text-align: center">
                      <LoadingVue></LoadingVue>
                    </div>
                    <div
                      v-if="errMsg !== ''"
                      class="d-flex justify-content-center"
                      style="color: red"
                    >
                      <span>{{ errMsg }}</span>
                    </div>
                    <div
                      v-if="isVerifiedEmail == false"
                      class="d-flex justify-content-center"
                      style="color: red"
                    >
                      <span>{{ $t("VA_VERIFIED_EMAIL") }}</span>
                    </div>
                  </div>
                  <span class="text-check-box text-center"
                    >{{ $t('TXT_BY_CONTINUING') }} &nbsp;<u
                      @click="termModalClick"
                      class="underline cursor-pointer"
                    >
                      {{ $t('TXT_TERMS_CONDITIONS') }} </u
                    >&nbsp; {{ $t('TXT_AND_ACKNOWLEDGE') }}&nbsp;
                    <u class="cursor-pointer underline" @click="privacyClick">
                      {{ $t('TXT_PRIVACY_POLICY') }}
                    </u>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-12 col-lg-5 p-0">
          <img src="@/assets/img-right-form.png" class="mw-100" alt="" />
        </div> -->
      </div>
    </div>
    <ModalTermAndCondition />
    <ModalPrivacy />
  </div>
</template>

<script>
import axios from "axios";
import { apiURL } from "@/configs/serverConfig";
import LoadingVue from "@/components/LoadingMask.vue";
import ModalTermAndCondition from "@/components/Modal/ModalTermAndCondition";
import ModalPrivacy from "@/components/Modal/ModalPrivacy.vue";
import { httpClient } from "@/token/axios";
import Cookies from "js-cookie";
export default {
  components: {
    LoadingVue,
    ModalTermAndCondition,
    ModalPrivacy,
  },
  name: "SigninView",
  data: () => {
    return {
      email: null,
      password: null,
      errMsg: "",
      isVerifiedEmail: null,
      loading: false,
      accessToken: null,
      isShowPassword: false,
    };
  },
  created() {
    this.$store.dispatch("setAccessFrom", "");
    localStorage.removeItem("keyWaste");
  },
  methods: {
    termModalClick() {
      this.$bvModal.show("modal-term");
    },
    privacyClick() {
      this.$bvModal.show("modal-privacy");
    },
    validateSignin() {
      // this.loading = true;
      if (this.email === null) {
        this.errMsg = "Please input your email address.";
      } else if (this.password === null) {
        this.errMsg = "Please input your password.";
      } else {
        this.loading = true;
        axios
          .post(`${apiURL}/guest/login`, {
            email: this.email,
            password: this.password,
            login_type: 0,
            access_token: "",
          })
          .then(async (response) => {
            this.accessToken = response.data.access_token;
            await this.getMainCompany();
            await this.getCompanyData();
            await this.getUser();
            // if (this.isVerifiedEmail == true) {
            //   this.$store.commit("setToken", response.data.access_token);
            //   this.loading = false;
            //   await this.$router.push({ name: "MainMobileView" });
            // }
          })
          .finally(() => {
            this.loading = false;
          })
          .catch((err) => {
            this.errMsg = this.$t("TXT_ERROR_TRY_AGAIN");
            if (err.response.data.code) {
              this.errMsg = err.response.data.message;
            }
          });
      }
    },
    async getUser() {
      const url = `${apiURL}/user`;

      try {
        const user = await httpClient.get(url);
        this.$i18n.locale = user.data.language;
        await this.$store.dispatch("selectLang/setLanguage", user.data.language);
        Cookies.set("user_lang", user.data.language);
      } catch (err) {
        this.$toast.error({
          component: "styled-toast",
          props: {
            type: "error",
            message: err.response.data.message,
          },
        });
      }
    },
    async getMainCompany() {
      const url = `${apiURL}/member`;

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.accessToken}`,
      };

      try {
        const main_company = await axios.get(url, { headers: headers });
        if (main_company.data) {
          if (
            main_company.data.user &&
            main_company.data.user.is_verified != false
          ) {
            this.$store.commit("setToken", this.accessToken);

            this.$store.dispatch(
              "setCompanyId",
              main_company.data.main_company_id
            );
            this.$store.dispatch(
              "setCompanyName",
              main_company.data.main_company.name_th
            );
            if (main_company.data.main_company_role) {
              this.$store.dispatch(
                "setRoleId",
                main_company.data.main_company_role.id
              );
              this.$store.dispatch(
                "setRoleAction",
                main_company.data.main_company_role.group_roles
              );
            }

            if (main_company.data.main_company.file) {
              this.$store.dispatch(
                "setCompanyImage",
                main_company.data.main_company.file.file_url
              );
            } else {
              this.$store.dispatch("setCompanyImage", null);
            }

            this.$store.dispatch("setAdminType", main_company.data.type);
            this.$store.dispatch(
              "setUpType",
              main_company.data.main_company.set_up_type
            );
            await this.$store.dispatch(
              "setPermissionLogin",
              main_company.data.page_permission
            );
            if (main_company.data.main_company.set_up_type == 0) {
              // 0 ยังไม่ได้ตั้งค่า 1 ตั่งค่าอย่างง่าย 2 แบบละเอียด
              await this.$router.push({ name: "Not Support" });
            } else {
              await this.$router.push({ name: "MainMobileView" });
            }
          } else {
            // email is not verify
            this.isVerifiedEmail = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getCompanyData() {
      const url = `${apiURL}/company?is_default=true`;
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.accessToken}`,
      };

      try {
        const company_data = await httpClient.get(url, { headers: headers });
        let company_default = company_data.data.entities.filter(
          (data) => data.is_default == true
        );
        if (company_default) {
          this.$store.dispatch("setCompanyData", company_default);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.bg-form {
  background-color: #212e3e;
  background-image: url("../assets/bg-form-mobile.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
  color: #fff;
}
.text-check-box {
  color: var(--text-subtitle, #51646b);
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  /* 175% */
}

.forgot-password {
  color: #2867eb;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  /* 171.429% */
}

.text-herder-login {
  font-size: 40px;
  font-family: "Noto Sans Thai", sans-serif;
  color: #fff;
  font-weight: 700;
}

.start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #4db671;
}

.btn-signin {
  font-size: 10px;
  padding: 5px;
  width: 100%;
  text-align: center;
  background-color: #fff;
  color: #265054;
  height: 50px;
  border-radius: 10px;
  text-transform: uppercase;
  border: 1px solid #265054;
}

.login-choice span {
  color: #5b6987;
  display: -ms-grid;
  display: grid;
  font-size: 16px;
  width: 100%;
  line-height: 40px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  -ms-grid-columns: minmax(20px, 1fr) auto minmax(20px, 1fr);
  grid-template-columns: minmax(20px, 1fr) auto minmax(20px, 1fr);
  grid-gap: 19px;
}

.login-choice span:after,
.login-choice span:before {
  content: "";
  border-top: 1px solid #e5e8ed;
}

.form-fields,
.form-fields button {
  width: 100%;
  margin: 5px 0;
  line-height: 28px;
  border-radius: 5px;
}

.form-fields input {
  width: 100%;
  line-height: 40px;
  border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #51646b;
  background: unset;
  padding: 0 5px;
  font-size: 14px;
}

.signIn {
  padding: 10px 32px;
  color: white;
  font-size: 16px;
  font-weight: 400;
  background: #51646b;
  text-align: center;
  cursor: pointer;
  height: auto;
  -webkit-appearance: none;
}

.createaccount {
  padding: 15px;
  background-color: #0069ff;
  border: none;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  height: 48px;
  line-height: 48px;
  padding: 0 32px;
  text-align: center;
  border-radius: 5px;
}
</style>
